export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00641.599c2bb7.png";